import React from 'react';
import { Menu, Image } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';
import MenuItem from './Item.js';
import AuthButton from './AuthButton.js';
import LanguageSelector from './LanguageSelector.js';


const Header = (props) => {
  const {
    t,
    activeLang,
    languageOptions,
    onChangeLanguage,
    groups,
    username,
    onAuthButtonClick
  } = props;
  
  return (
    <div className='rtxHeader'>
      <Menu secondary inverted>
         <Image src='/robotex_logo_white.svg' size='small' className='rtxLogo' />
        <Menu.Menu position='right'>
          <Menu.Item>
            <LanguageSelector
              options={languageOptions}
              activeLang={activeLang}
              onChangeLanguage={onChangeLanguage}
            />
          </Menu.Item>
          <MenuItem name={t('common:header.events')} to='' />
          <MenuItem name={t('common:header.my')} to='/my' hide={!username || groups.includes('ADMIN')} />
          <MenuItem name={t('common:header.admin')} to='/admin' hide={!groups.includes('ADMIN')} />
          <MenuItem name={t('common:header.referee')} to='/referee' hide={!groups.includes('REFEREE')} />
          <Menu.Item>
            <AuthButton
              name={username ? t('common:auth.signout') : t('common:auth.signin')}
              onClick={onAuthButtonClick} 
            />
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    </div>
  );
};

export default withNamespaces('common')(Header);



// WEBPACK FOOTER //
// ./src/common/components/Header/index.js